import { Fragment } from 'preact';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize, { defaultSchema } from 'rehype-sanitize';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import remarkGithub from 'remark-github';
import { useApi } from '../hooks/api';

export type MarkdownProps = {
    markdown: string;
    inline?: boolean;
    openLinksInNewTab?: boolean;
};
export const Markdown = (props: MarkdownProps) => {
    const api = useApi();

    if (!api) return <>'Loading…'</>;

    const component = (
        <ReactMarkdown
            children={props.markdown}
            rehypePlugins={[[rehypeSanitize, defaultSchema]]}
            remarkPlugins={[
                remarkBreaks,
                remarkGfm,
                [remarkGithub, { repository: `${api.repository.owner}/${api.repository.repo}` }],
            ]}
            components={{
                ...(props.openLinksInNewTab !== false && {
                    // eslint-disable-next-line jsx-a11y/anchor-has-content, @typescript-eslint/no-explicit-any
                    a: (props: any) => <a {...props} target="_blank" rel="noopener noreferrer" />,
                }),
                ...(props.inline && { p: Fragment }),
            }}
        />
    );

    return component;
};
